import { ICollection, Collection } from './Collection';

export interface IKeyValPair {
  Anahtar: string;
  Deger: number;
}

export interface IError {
  ErrorCode: string | undefined;
  ErrorTitle: string | undefined;
  ErrorMessage: string;
  ErrorDateTime: string;
}

export interface IBaseStateModel {
  Error: IError | null | undefined;
  Initiated: boolean;
  InProgress: boolean;
}

export interface IObjectStateModel extends IBaseStateModel {
  Obj: object | null | undefined;
}

export interface IKeyValPairStateModel extends IBaseStateModel {
  Data: Collection<IKeyValPair> | null | undefined;
}

export interface IInputDataStateModel<TInput, TData> extends IBaseStateModel {
  Data: TData | null | undefined;
  Input: TInput | null | undefined;
}

export interface IKeyValPairAndInputStateModel<T> extends IKeyValPairStateModel {
  Input: T | null | undefined;
}

export const DefaultObjectState: IObjectStateModel = {
  Obj: {},
  Error: null,
  Initiated: false,
  InProgress: false,
};

export const DefaultIKeyValPairState: IKeyValPairStateModel = {
  Data: new Collection<IKeyValPair>([]),
  Error: null,
  Initiated: false,
  InProgress: false,
};

export const DefaultInputDataStateModel = <TInput, TData>(): IInputDataStateModel<
  TInput,
  TData
> => {
  return {
    Data: null,
    Error: null,
    Input: null,
    Initiated: false,
    InProgress: false,
  };
};

export const DefaultIKeyValPairAndInputStateModel = <T>(): IKeyValPairAndInputStateModel<T> => {
  return {
    Data: new Collection<IKeyValPair>([]),
    Error: null,
    Input: null,
    Initiated: false,
    InProgress: false,
  };
};

export class ObjectStateModel implements IObjectStateModel {
  public Obj: object = {};
  public Error: IError | null | undefined = null;
  public Initiated: boolean = false;
  public InProgress: boolean = false;
}

export class KeyValPairStateModel implements IKeyValPairStateModel {
  public Data: Collection<IKeyValPair> = new Collection<IKeyValPair>([]);
  public Error: IError | null | undefined = null;
  public Initiated: boolean = false;
  public InProgress: boolean = false;
}
